import React, { Component } from 'react';
import _ from 'lodash';
import { List, Header, Container } from 'semantic-ui-react';

class SecuritySection extends Component
{
   render()
    {
        if( _.get( this.props, 'report.data.dependencySecurityIssues.issues.length', 0 ) === 0 )
        {
            return null;
        }

        const entries = _.map(
            this.props.report.data.dependencySecurityIssues.issues,
            ( issue, index ) => {
                return (
                    <List.Item
                        key={index}
                        icon={`warning sign`}
                        header={ ( <a className={`header`} href={issue.advisory}>{issue.module} {issue.version}</a> ) }
                        description={`${issue.title} -- ${issue.overview}`}
                    />
                );
            }
        );

        return (
            <Container className='Security'>
                <Header size={`large`}>NPM Dependency Security Issues</Header>

                <List>
                    {entries}
                </List>
            </Container>
        );
    }
}

export default SecuritySection;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/Sections/Security.js